import { render, staticRenderFns } from "./FhDate.vue?vue&type=template&id=97b09d76&scoped=true&"
import script from "./FhDate.vue?vue&type=script&lang=js&"
export * from "./FhDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b09d76",
  null
  
)

export default component.exports